import React from "react";
import styles from "./ActionPacks.module.css";

const ActionPacks = () => {
  return (
    <div className={styles.container}>
      <h1>Action Packs</h1>
      <p>This is a blank Action Packs page. Add your HTML and CSS here.</p>
    </div>
  );
};

export default ActionPacks;
